/** Etiquetas y orden de CCAAs soportadas en el wizard (landing futura). */

export const CCAA_LABELS: Record<string, string> = {
  madrid: 'Comunidad de Madrid',
  castilla_leon: 'Castilla y León',
  'castilla-y-leon': 'Castilla y León',
  extremadura: 'Extremadura',
  galicia: 'Galicia',
  valencia: 'Comunidad Valenciana',
  'comunidad-valenciana': 'Comunidad Valenciana',
  andalucia: 'Andalucía',
  catalunya: 'Cataluña',
  cataluna: 'Cataluña',
  murcia: 'Región de Murcia',
  aragon: 'Aragón',
  navarra: 'Navarra',
  rioja: 'La Rioja',
  'la-rioja': 'La Rioja',
  cantabria: 'Cantabria',
  asturias: 'Asturias',
  pais_vasco: 'País Vasco',
  'pais-vasco': 'País Vasco',
  castilla_mancha: 'Castilla-La Mancha',
  'castilla-la-mancha': 'Castilla-La Mancha',
  baleares: 'Islas Baleares',
  canarias: 'Canarias',
  ceuta: 'Ceuta',
  melilla: 'Melilla',
};

export const MODALITY_LABELS: Record<string, string> = {
  continental: 'Continental / aguas interiores',
  maritima: 'Marítima',
  maritima_tierra: 'Marítima desde tierra',
  maritima_embarcacion: 'Marítima embarcación',
  maritima_submarina: 'Marítima submarina',
  esparavel: 'Esparavel',
  interautonomica: 'Interautonómica',
};

export const SUBTERRITORIO_LABELS: Record<string, string> = {
  mallorca: 'Mallorca',
  menorca: 'Menorca',
  eivissa: 'Eivissa',
  formentera: 'Formentera',
  araba: 'Araba / Álava',
  bizkaia: 'Bizkaia',
  gipuzkoa: 'Gipuzkoa',
};

export const CHECKOUT_REQUIREMENT_LABELS: Record<string, string> = {
  certificado_medico: 'Certificado médico',
  documentacion_embarcacion: 'Documentación de embarcación',
  examen_aprobado: 'Examen aprobado',
  empadronamiento: 'Empadronamiento',
  dni_o_nie_obligatorio: 'DNI o NIE obligatorio',
  seguro_rc_accidentes: 'Seguro de RC y de accidentes (póliza y recibo)',
};

export const CHECKOUT_REQUIREMENT_OPTIONS = [
  'certificado_medico',
  'documentacion_embarcacion',
  'examen_aprobado',
  'empadronamiento',
  'dni_o_nie_obligatorio',
  'seguro_rc_accidentes',
] as const;

export const CCAA_OPTIONS = [
  'andalucia',
  'aragon',
  'asturias',
  'baleares',
  'canarias',
  'cantabria',
  'castilla-la-mancha',
  'castilla-y-leon',
  'cataluna',
  'ceuta',
  'comunidad-valenciana',
  'extremadura',
  'galicia',
  'madrid',
  'melilla',
  'murcia',
  'navarra',
  'pais-vasco',
  'rioja',
] as const;

export const MODALITY_OPTIONS = [
  'continental',
  'maritima',
  'maritima_tierra',
  'maritima_embarcacion',
  'maritima_submarina',
  'esparavel',
  'interautonomica',
] as const;

export const FEE_VARIANT_KIND_OPTIONS = [
  { value: 'eslora', label: 'Eslora' },
  { value: 'residente', label: 'Residente' },
  { value: 'recargo', label: 'Recargo' },
  { value: 'general', label: 'General' },
  { value: 'other', label: 'Otro' },
] as const;

/** Subterritorios admitidos por CCAA (+ modalidad cuando aplica). */
export function subterritorioOptionsFor(ccaa: string, modality: string): string[] {
  const key = String(ccaa || '').toLowerCase();
  const mod = String(modality || '').toLowerCase();
  if (key === 'baleares') {
    return ['mallorca', 'menorca', 'eivissa', 'formentera'];
  }
  if (key === 'pais-vasco' && mod === 'continental') {
    return ['araba', 'bizkaia', 'gipuzkoa'];
  }
  return [];
}

export function ccaaLabel(code: string): string {
  const key = String(code || '').toLowerCase();
  return (
    CCAA_LABELS[key] ||
    CCAA_LABELS[key.replace(/-/g, '_')] ||
    CCAA_LABELS[key.replace(/_/g, '-')] ||
    code
  );
}

export function modalityLabel(code: string): string {
  return MODALITY_LABELS[code] || code;
}

export function subterritorioLabel(code: string): string {
  if (!code) return '—';
  return SUBTERRITORIO_LABELS[code] || code;
}

export function checkoutRequirementLabel(code: string): string {
  return CHECKOUT_REQUIREMENT_LABELS[code] || code;
}
